import { Switch, Route } from "wouter";
import { Layout } from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Reconcile from "./pages/Reconcile";
import ChangeSet from "./pages/ChangeSet";
import Sync from "./pages/Sync";
import Settings from "./pages/Settings";
import ComparisonView from "./pages/ComparisonView";
import SafetyReview from "./pages/SafetyReview";
import UnitMismatches from "./pages/UnitMismatches";
import Activity from "./pages/Activity";
import Handleiding from "./pages/Handleiding";
import Changelog from "./pages/Changelog";
import { ErrorBoundary } from "./components/ErrorBoundary";

export default function App() {
  return (
    <ErrorBoundary where="app shell">
      <Layout>
        <ErrorBoundary where="page">
          <Switch>
        <Route path="/" component={Dashboard} />
        <Route path="/products/:code" component={ProductDetail} />
        <Route path="/products" component={Products} />
        <Route path="/compare/exact">{() => <ComparisonView system="exact" />}</Route>
        <Route path="/compare/ls">{() => <ComparisonView system="ls" />}</Route>
        <Route path="/reconcile/:id" component={ChangeSet} />
        <Route path="/reconcile" component={Reconcile} />
        <Route path="/safety-review" component={SafetyReview} />
        <Route path="/unit-mismatches" component={UnitMismatches} />
        <Route path="/sync" component={Sync} />
        <Route path="/activity" component={Activity} />
        <Route path="/settings" component={Settings} />
        <Route path="/handleiding" component={Handleiding} />
        <Route path="/changelog" component={Changelog} />
            <Route><div className="text-slate-500">Page not found.</div></Route>
          </Switch>
        </ErrorBoundary>
      </Layout>
    </ErrorBoundary>
  );
}
